import NewOrder from '@app/components/order/NewOrder';
import React from 'react';

const OrderNewPage: React.FC = () => {
  
  return (
    <NewOrder />
  );
};

export default OrderNewPage;
